import { makeStyles } from "@mui/styles";
import { getSharedStyles } from "../../../shared/shared-styles";

export const useStyles = makeStyles((theme) => ({
  ...getSharedStyles(theme),
  headerSection: {
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  procurementSection: {
    marginBottom: theme.spacing(3),
  },
  description: {
    color: "#6b7280",
    fontSize: "18px",
    maxWidth: "672px",
    margin: "0 auto",
  },
  card: {
    padding: "24px",
    overflow: "visible",
  },
  fieldsContainer: {
    "& > * + *": {
      marginTop: "20px",
    },
  },
  fieldLabel: {
    display: "block",
    fontSize: "14px",
    fontWeight: 700,
    marginBottom: "8px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "8px",
  },
  buttonRow: {
    display: "flex",
    gap: "16px",
  },
  infoBox: {
    backgroundColor: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: "8px",
    padding: "16px",
  },
  infoText: {
    fontSize: "14px",
    color: "#1e40af",
    margin: 0,
  },
  navRow: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "16px",
    marginTop: "24px",
  },
  rightIcon: {
    marginLeft: "8px",
  },
}));
